<template>
  <v-app id="app" v-bind:style="{ backgroundImage: 'url(\'' + baseUrl +'v1/api/public/wallpaper/\')' }">
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: 'app',
  data() {
    return {
      baseUrl: axios.defaults.baseURL
    }
  }
}
</script>

<style>
#app {
  font-family: Raleway, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  background-size: cover;
}

/*
 * Generally dont center selects/lists ever
 */
.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle {
  text-align: left;
}

.v-application a.caption {
  font-size: 0.8rem !important;
}
</style>
